import {
  type ReactNode, useMemo, useState, useEffect,
} from 'react';
import ChatContext from './ChatContext';
import { ChatStates, ChatIdentity, ChatConfig } from './chatTypes';

interface Props {
  locale: string;
  locationHref: string;
  locationPathName: string;
  identity: ChatIdentity;
  chatConfig: ChatConfig;
  children: ReactNode;
}

const ChatProvider = ({
  locale,
  locationHref,
  locationPathName,
  identity,
  chatConfig,
  children,
}: Props) => {
  const [chatStatus, setChatStatus] = useState<ChatStates>('initial');

  useEffect(() => {
    // Set ChatStatus to second or third state based on config
    if (chatStatus !== 'unavailable'
      && (!chatConfig.zendeskKey || !chatConfig.channel)) {
      setChatStatus('unavailable');
    } else if (chatStatus === 'initial' && chatConfig.enabled) {
      setChatStatus('waiting');
    }
  }, [chatStatus, chatConfig]);

  const ChatContextContent = useMemo(() => ({
    chatStatus,
    setChatStatus,
    chatConfig,
    locale,
    locationHref,
    locationPathName,
    identity,
  }), [
    chatStatus,
    chatConfig,
    locale,
    locationHref,
    locationPathName,
    identity,
  ]);

  return (
    <ChatContext.Provider value={ChatContextContent}>
      {children}
    </ChatContext.Provider>
  );
};

export default ChatProvider;
